import React, { useState } from 'react';
import PropTypes from "prop-types";

import "./style.scss";

/**
 *
 * @param props
 * @returns {*}
 * @constructor
 */
function MiniSteps(props){

    let steps={};
    props.steps.map(v=>{steps[v]=false});

    const [doneSteps, setDoneSteps] = useState(steps);
    function markAsDone(v){
        if(!doneSteps[v]) {
            doneSteps[v] = true;
            setDoneSteps(doneSteps);
        }
    }

    return (
        <div className="MiniSteps">
            <ul>
            {props.steps.map( v =>{

                let isActive = props.currentStep == v;
                if( isActive )
                    markAsDone(v); //could use effect Hook..

                return(
                <li key={v}
                    className={"step " + (doneSteps[v] ? "done " : "") + (isActive ? "active" : "")}
                    onClick={()=>{
                        if( doneSteps[v] )
                            props.onStepClick(v);
                    }}/>)}
            )}
            </ul>
        </div>
    );
}

MiniSteps.propTypes = {
    steps: PropTypes.array,
    currentStep: PropTypes.number,
    onStepClick: PropTypes.func
};

export default MiniSteps;
